import { atom, useSetRecoilState, useRecoilValue } from "recoil";

const fundTransferAtom = atom({
  key: 'fund_transfer_atom',
  default: { fund_transfer: [], trans_rec_chart_of_accounts: [] },
});

const fundTransferEditAtom = atom({ key: 'fund_transfer_edit_atom', default: null });

export const SetFundTransferAtom = () => useSetRecoilState(fundTransferAtom);
export const GetFundTransferAtom = () => useRecoilValue(fundTransferAtom);

export const SetFundTransferEditAtom = () => useSetRecoilState(fundTransferEditAtom);
export const GetFundTransferEditAtom = () => useRecoilValue(fundTransferEditAtom);
